import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { MenuItem, FormControlLabel, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import { Field } from 'formik';

import FormikCheckBox from 'components/theme/formik/checkbox';
import FormikTextField from 'components/theme/formik/text-field';
import { messages } from 'app-constants';

const useStyles = makeStyles(
  (theme) => ({
    select: {
      marginLeft: theme.spacing.unit,
      marginTop: theme.spacing.unit,
      minWidth: 50
    },
    selectLabel: {
      margin: 0,
      cursor: 'default',
      whiteSpace: 'nowrap'
    },
    gridColumn: {
      flexBasis: 'auto',
      padding: [[0, theme.spacing.unit * 2, 0, 0]]
    },
    textInput: {
      margin: [[theme.spacing.unit, 0]],
      '& fieldset': {
        maxWidth: '200px'
      }
    }
  }),
  { withTheme: true }
);

export default function ConditionAppVersionTarget(props) {
  const classes = useStyles();

  const { condition, index } = props;
  const disabled = !condition.enable;

  return (
    <>
      <FormControlLabel
        control={
          <Field
            name={`conditions[${index}].enable`}
            component={FormikCheckBox}
            color="primary"
          />
        }
        label={messages.CONDITIONS[condition.conditionType].title}
      />

      <Grid container>
        <Grid item xs={12} lg={4} className={classes.gridColumn}>
          <Field
            name={`conditions[${index}].conditionRule`}
            render={(fieldProps) => {
              return (
                <FormControlLabel
                  className={classes.selectLabel}
                  disabled={disabled}
                  control={
                    <FormikTextField
                      select
                      disabled={disabled}
                      className={classes.select}
                      data-testid="select-version-condition"
                      {...fieldProps}
                    >
                      <MenuItem value="EQ" key="equal">
                        =
                      </MenuItem>
                      <MenuItem value="GE" key="greater-than-or-equal">
                        {'>='}
                      </MenuItem>
                    </FormikTextField>
                  }
                  label="App version is"
                  labelPlacement="start"
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4} className={classes.gridColumn}>
          <Field
            name={`conditions[${index}].conditionTarget`}
            render={(fieldProps) => {
              return (
                <FormikTextField
                  disabled={disabled}
                  className={classes.textInput}
                  data-testid="input-app-version"
                  placeholder="Enter app version"
                  required
                  {...fieldProps}
                />
              );
            }}
          />
        </Grid>
      </Grid>
      <Typography
        variant="caption"
        gutterBottom
        color={disabled ? 'textSecondary' : 'default'}
      >
        <i>Feature will turn on if app version is matched.</i>
        <br /> App version value is in format of version.release.modification
        where version, release and modification are either a set of digits or
        the {"'*'"} wildcard character. Additionally, any of these numbers (and
        any preceding .) may be missing.
        <br /> {' => '} Valid examples :
        <br /> 1.23.456 = version 1, release 23, modification 456
        <br /> 1.23 OR 1.23.*= version 1, release 23, any modification
        <br /> 1 OR 1.* = version 1, any release, any modification
        <br /> * = any version, any release, any modification
        <br />
        {' => '} Invalid examples: *.12, *123.1, 12*, 12.*.34
      </Typography>
    </>
  );
}
